<template>
  <div class="jumbotron divider-if-large">
    <div class="row">
      <div class="col">
        <img src="/static/HorizontalYarlowLogo.svg">
        <h2>Menu</h2>
        <hr class="solid">
        <router-link v-bind:to="{ path: dashboard }">
          <h4 class="secondary-nav"
              v-bind:class="{ secondarynavcolored: endPath === 'dashboard' }">Dashboard</h4>
        </router-link>
        <router-link v-bind:to="{ path: details }">
          <h4 class="secondary-nav"
              v-bind:class="{ secondarynavcolored: endPath === 'details' }">Details</h4>
        </router-link>
        <router-link to="/profile/user/pictures" v-if="user">
          <h4 class="secondary-nav"
              v-bind:class="{ secondarynavcolored: endPath === 'pictures' }">Photos</h4>
        </router-link>
        <!--<router-link to="/profile/user/alerts">
          <h4 class="secondary-nav"
              v-bind:class="{ secondarynavcolored: endPath === 'alerts' }">Alerts</h4>
        </router-link>
        <router-link to="/profile/user/wallet">
          <h4 class="secondary-nav"
              v-bind:class="{ secondarynavcolored: endPath === 'wallet' }">Wallet</h4>
        </router-link>-->
        <router-link to="/profile/user/profiles" v-if="user">
          <h4 class="secondary-nav"
              v-bind:class="{ secondarynavcolored: endPath === 'profiles' }">Profiles</h4>
        </router-link>
        <router-link to="/profile/realtor/subscriptions" v-if="realtor">
          <h4 class="secondary-nav"
              v-bind:class="{ secondarynavcolored: endPath === 'subscriptions' }">Subscriptions</h4>
        </router-link>
        <router-link to="/profile/realtor/paymentinfo" v-if="realtor">
          <h4 class="secondary-nav"
              v-bind:class="{ secondarynavcolored: endPath === 'paymentinfo' }">Payment Info</h4>
        </router-link>
        <router-link to="/profile/realtor/support" v-if="realtor">
          <h4 class="secondary-nav"
              v-bind:class="{ secondarynavcolored: endPath === 'support' }">Support</h4>
        </router-link>
        <router-link to="/profile/serviceprovider/subscriptions" v-if="serviceProvider">
          <h4 class="secondary-nav"
              v-bind:class="{ secondarynavcolored: endPath === 'subscriptions' }">Subscriptions</h4>
        </router-link>
        <router-link to="/profile/serviceprovider/paymentinfo" v-if="serviceProvider">
          <h4 class="secondary-nav"
              v-bind:class="{ secondarynavcolored: endPath === 'paymentinfo' }">Payment Info</h4>
        </router-link>
        <router-link to="/profile/serviceProvider/support" v-if="serviceProvider">
          <h4 class="secondary-nav"
              v-bind:class="{ secondarynavcolored: endPath === 'support' }">Support</h4>
        </router-link>
        <h2>Preferences</h2>
        <hr class="solid">
        <router-link to="/profile/user/security">
          <h4 class="secondary-nav"
              v-bind:class="{ secondarynavcolored: endPath === 'security' }"
              v-if="getIdProvider !== 'google'">Security</h4>
        </router-link>
        <router-link to="/">
          <h4 class="secondary-nav"
              v-on:click="logOut">Log Out</h4>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      endPath: null
    }
  },
  created () {
    this.setEndPath()
  },
  watch: {
    '$route' (to, from) {
      this.setEndPath()
    }
  },
  computed: {
    ...mapGetters([
      'getIdProvider'
    ]),
    ...mapGetters('user', [
      'getUserType'
    ]),
    dashboard () {
      if (this.getUserType === 'service provider') return '/profile/serviceProvider/dashboard'
      if (this.getUserType === 'realtor') return '/profile/realtor/dashboard'
      return '/profile/user/dashboard'
    },
    details () {
      if (this.getUserType === 'service provider') return '/profile/serviceProvider/details'
      if (this.getUserType === 'realtor') return '/profile/realtor/details'
      return '/profile/user/details'
    },
    realtor () {
      return this.getUserType === 'realtor'
    },
    serviceProvider () {
      return this.getUserType === 'service provider'
    },
    user () {
      return this.getUserType === 'user'
    }
  },
  methods: {
    setEndPath () {
      var pathList = (this.$route.path).split('/')
      this.endPath = pathList[3]
    },
    logOut () {
      this.$global.gaEvent('userLogOut', 'backendCall')
      this.$store.dispatch('logOut')
    }
  }
}
</script>

<style scoped>
@media (min-width: 992px) {
  .divider-if-large {
    border-right: solid;
  }
}

.jumbotron {
  background-color: #fff !important;
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-right: 0rem;
  padding-bottom: 1rem;
}

.secondary-nav {
  border-radius: 15px;
  padding: 10px;
  padding-left: 20px;
}

.secondary-nav:hover {
  background-color: #feedaa;
}

.secondarynavcolored {
  background-color: #feedaa;
}

.solid {
  border-top: solid black;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/userProfile/UserSubnav.vue